import React from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import {
  errorLoadingProductsContainer,
  errorLoadingProductsHeader,
  errorLoadingProductsBody,
} from './styles';

const ProductsError = () => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <div css={errorLoadingProductsContainer}>
      <div data-testid="ProductsError_Header" css={errorLoadingProductsHeader}>
        {T.translate('PRODUCTS_LOAD_ERROR_HEADER')}
      </div>
      <div data-testid="ProductsError_Body" css={errorLoadingProductsBody}>
        {T.translate('PRODUCTS_LOAD_ERROR_BODY')}
      </div>
    </div>
  );
};

export default ProductsError;
